<script>
import { useMainStore, useEventStore } from '../../../stores/index';
import ProgressBarDocs from './ProgressBar.vue';
import Editor from '@tinymce/tinymce-vue';
import RequiredFill from '../Modals/RequiredFill.vue';
import documentAi from '../../../Services/documentAi';
const MIN_SELECTION_LENGTH = 10;
export default {
  name: 'DashboardDefault',
  components: { Editor, ProgressBarDocs, RequiredFill },
  setup () {
    const StoreAll = useMainStore();
    const Events = useEventStore();
    StoreAll.Token();
    return {
      Store: StoreAll,
      Events
    };
  },
  data () {
    return {
      subject: '',
      editorContent: '',
      editorConfig: {
        min_height: 800,
        height: 800,
        max_height: 800,
        resize: 'both',
        language: 'pt_BR',
        plugins: 'link image table quickbars',
        toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent  | advtablerownumbering | quickimage | fontsizeinput',
        setup: (editor) => {
          this.tinymceEditor = editor;
          editor.on('SelectionChange NodeChange KeyUp', () => {
            this.hasValidSelection = editor.selection.getContent({ format: 'text' }).trim().length >= MIN_SELECTION_LENGTH;
          });
          editor.on('init SetContent input change Undo Redo KeyUp', () => {
            this.hasBodyContent = this.bodyContentNodes(editor).length > 0;
          });
        }
      },
      typeDoc: [{ id: 0, title: 'Selecione' }],
      typeSelect: 0,
      AI_EXAMPLES: [
        { match: ['indenizat'], subject: 'RECONHECIMENTO DE DÍVIDA', text: 'Gere a abertura de um processo administrativo indenizatório para reconhecimento de dívida com fornecedor por serviço prestado sem cobertura contratual.' },
        { match: ['processo administrativo'], subject: 'APURAÇÃO DE FALTA FUNCIONAL', text: 'Gere a abertura de um processo administrativo para apurar falta funcional de servidor, com a designação de comissão responsável.' },
        { match: ['lei complementar'], subject: 'ALTERAÇÃO DO CÓDIGO TRIBUTÁRIO', text: 'Gere um projeto de lei complementar que altera o Código Tributário Municipal para atualizar a base de cálculo do IPTU, com ementa, artigos e justificativa.' },
        { match: ['lei ordin'], subject: 'PROGRAMA DE INCENTIVO À LEITURA', text: 'Gere um projeto de lei ordinária que institui o programa municipal de incentivo à leitura nas escolas públicas, com ementa, artigos e justificativa.' },
        { match: ['projeto de lei'], subject: 'DENOMINAÇÃO DE LOGRADOURO', text: 'Gere um projeto de lei que denomina um logradouro público do município em homenagem a cidadão falecido, com ementa, artigos e justificativa.' },
        { match: ['memorando'], subject: 'CONVOCAÇÃO PARA REUNIÃO', text: 'Gere um memorando convocando os coordenadores do setor para reunião de alinhamento das atividades do próximo mês.' },
        { match: ['oficio'], subject: 'SOLICITAÇÃO DE APOIO', text: 'Gere um ofício solicitando apoio de outra secretaria para a realização de um evento comunitário no município.' },
        { match: ['protocolo'], subject: 'RECEBIMENTO DE DOCUMENTOS', text: 'Gere um protocolo de recebimento de documentos entregues por empresa contratada para análise do setor responsável.' },
        { match: ['ouvidoria'], subject: 'RESPOSTA A MANIFESTAÇÃO', text: 'Gere uma resposta da Ouvidoria a um munícipe sobre reclamação de serviço público, informando que as providências foram encaminhadas ao setor competente.' },
        { match: ['internacao'], subject: 'AUTORIZAÇÃO DE INTERNAÇÃO', text: 'Gere uma autorização de internação hospitalar para paciente encaminhado pela unidade básica de saúde ao hospital municipal.' }
      ],
      AI_EXAMPLE_DEFAULT: { subject: 'COMUNICADO AOS SERVIDORES', text: 'Gere um comunicado aos servidores informando a mudança no horário de atendimento ao público a partir do próximo mês.' },
      aiModalOpen: false,
      aiPrompt: '',
      showTip: false,
      generatingAi: false,
      hasBodyContent: false,
      hasValidSelection: false,
      refineModalOpen: false,
      refiningAi: false,
      refineOriginalHtml: '',
      refineSuggestedHtml: '',
      refineSuggestionHistory: [],
      refineInstruction: '',
      refineStep: 'input',
      refineWholeDocument: false
    };
  },
  created () {
    this.aiAbortController = null;
    this.refineAbortController = null;
    this.refineBookmark = null;
    this.tinymceEditor = null;
  },
  mounted () {
    const typeNone = Array.isArray(this.Store.Types) ? [...this.Store.Types] : [];
    if (!typeNone.some(obj => obj.id === 0)) {
      typeNone.unshift({ id: 0, title: 'Selecione' });
    }
    this.typeDoc = typeNone;
    this.typeSelect = this.Store.documentData.typeDoc;

    if (this.Store.documentData.body) {
      this.subject = this.Store.documentData.subject || '';
      this.editorContent = this.Store.documentData.body;
    } else {
      this.subject = this.Store.documentData.subject || '';
      this.editorContent = (this.Store.user && this.Store.user.footer) ? this.Store.user.footer : '';
    }
  },
  watch: {
  },
  computed: {
    canGenerateWithAI () {
      return (this.subject || '').trim() !== '';
    },
    canRefineWithAI () {
      return this.hasBodyContent;
    },
    refineButtonTitle () {
      if (!this.hasBodyContent) return undefined;
      if (!this.hasValidSelection) return 'Aprimorar o documento com IA (ou selecione um trecho para revisar só ele)';
      return 'Revisar o trecho selecionado com IA';
    },
    aiExample () {
      const type = this.typeDoc.find(option => option.id === this.typeSelect);
      const title = (type?.title || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      return this.AI_EXAMPLES.find(item => item.match.some(keyword => title.includes(keyword))) || this.AI_EXAMPLE_DEFAULT;
    },
    aiPromptExample () {
      return this.aiExample.text;
    },
    showSubjectSuggestion () {
      const typed = (this.subject || '').trim();
      return typed === '' || (typed !== this.aiSubjectExample && this.aiSubjectExample.startsWith(typed));
    },
    aiSubjectExample () {
      return this.aiExample.subject;
    }
  },
  methods: {
    isContentEmpty (content) {
      if (!content || typeof content !== 'string') {
        return true;
      }
      if (/<img|<table|<iframe|<svg/i.test(content)) {
        return false;
      }
      const clean = content
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .trim();
      return clean.length === 0;
    },

    async nextProgress () {
      const hasValidType = this.typeSelect !== 0;
      const hasValidSubject = this.subject && this.subject.trim() !== '';
      const hasValidBody = !this.isContentEmpty(this.editorContent);

      if (!hasValidType || !hasValidSubject || !hasValidBody) {
        this.$refs.RequiredFill.openModal();
        return;
      }

      this.Store.documentData.typeDoc = this.typeSelect;
      this.Store.documentData.subject = this.subject;
      this.Store.documentData.body = this.editorContent;
      const body = [{ body: this.editorContent }];
      const contents = JSON.stringify(body);
      const data = {
        document_type_id: this.typeSelect,
        content: contents,
        is_new_document: true,
        subject: this.subject
      };

      try {
        if (this.Store.is_new_document) {
          await this.Store.CreateDraft(data);
        } else if (this.Store.draftID !== 0) {
          await this.Store.UpdateDraft(data);
        }
        this.Store.progress += 1;
      } catch (error) {
        console.error('Erro ao salvar rascunho:', error);
      }
    },

    backProgress () {
      this.Store.progress -= 1;
    },

    generateWithAI () {
      this.aiModalOpen = true;
      this.showTip = true;
      this.aiPrompt = '';
    },

    useAiPromptExample () {
      this.aiPrompt = this.aiPromptExample;
      this.showTip = false;
    },

    useSubjectSuggestion () {
      this.subject = this.aiSubjectExample;
    },

    async confirmGenerateWithAI () {
      if (!this.aiPrompt.trim()) {
        this.$toast.add({ severity: 'warn', summary: 'Prompt vazio', detail: 'Descreva o que a IA deve gerar.', life: 4000 });
        return;
      }
      this.generatingAi = true;
      this.aiAbortController = new AbortController();
      try {
        const resp = await documentAi.generate(
          { prompt: this.aiPrompt, subject: this.subject, documentTypeId: this.typeSelect },
          this.Store.accessToken,
          this.aiAbortController.signal
        );
        const body = resp.data.result?.body ?? '';
        this.editorContent = body + (this.Store.user?.footer || '');
        this.aiModalOpen = false;
        this.aiPrompt = '';
        this.showTip = false;
      } catch (err) {
        if (err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError') return;
        this.$toast.add({ severity: 'error', summary: 'Erro ao gerar', detail: 'Não foi possível gerar o documento com IA.', life: 5000 });
      } finally {
        this.generatingAi = false;
        this.aiAbortController = null;
      }
    },

    closeAiModal () {
      if (this.generatingAi && this.aiAbortController) {
        this.aiAbortController.abort();
      }
      this.aiModalOpen = false;
    },

    bodyContentNodes (editor) {
      const isContentNode = node => (node.nodeType === 1 && (node.textContent.trim() !== '' || /^(IMG|TABLE|IFRAME|SVG)$/.test(node.nodeName) || node.querySelector('img, table, iframe, svg'))) || (node.nodeType === 3 && node.textContent.trim() !== '');
      const isFooterNode = node => node.nodeType === 1 || (node.nodeType === 3 && node.textContent.trim() !== '');
      const nodes = Array.from(editor.getBody().childNodes).filter(isFooterNode);
      const footer = this.Store.user?.footer || '';
      const footerCount = footer
        ? Array.from(new DOMParser().parseFromString(footer, 'text/html').body.childNodes).filter(isFooterNode).length
        : 0;
      const body = nodes.slice(0, Math.max(nodes.length - footerCount, 0));
      return body.some(isContentNode) ? body : [];
    },

    selectBodyWithoutFooter (editor) {
      const nodes = this.bodyContentNodes(editor);
      if (nodes.length === 0) return false;
      const range = editor.dom.createRng();
      range.setStartBefore(nodes[0]);
      range.setEndAfter(nodes[nodes.length - 1]);
      editor.selection.setRng(range);
      return true;
    },

    openRefineModal () {
      if (!this.tinymceEditor || !this.canRefineWithAI) return;
      this.refineWholeDocument = !this.hasValidSelection;
      if (this.refineWholeDocument && !this.selectBodyWithoutFooter(this.tinymceEditor)) return;
      this.refineOriginalHtml = this.tinymceEditor.selection.getContent({ format: 'html' });
      this.refineBookmark = this.tinymceEditor.selection.getBookmark(2);
      this.refineInstruction = '';
      this.refineSuggestedHtml = '';
      this.refineSuggestionHistory = [];
      this.refineStep = 'input';
      this.refineModalOpen = true;
    },

    async confirmRefineInstruction () {
      if (!this.refineInstruction.trim()) return;
      this.refiningAi = true;
      this.refineAbortController = new AbortController();
      try {
        const resp = await documentAi.refineSelection(
          {
            selectionHtml: this.refineOriginalHtml,
            documentHtml: this.editorContent,
            instruction: this.refineInstruction,
            previousSuggestions: this.refineSuggestionHistory
          },
          this.Store.accessToken,
          this.refineAbortController.signal
        );
        this.refineSuggestedHtml = resp.data.result?.revised ?? '';
        this.refineStep = 'result';
      } catch (err) {
        if (err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError') return;
        this.$toast.add({ severity: 'error', summary: 'Erro ao revisar', detail: 'Não foi possível revisar o trecho selecionado.', life: 5000 });
      } finally {
        this.refiningAi = false;
        this.refineAbortController = null;
      }
    },

    backToRefineInstruction () {
      if (this.refineSuggestedHtml) {
        this.refineSuggestionHistory = [...this.refineSuggestionHistory, this.refineSuggestedHtml].slice(-10);
      }
      this.refineSuggestedHtml = '';
      this.refineInstruction = '';
      this.refineStep = 'input';
    },

    applyRefineSuggestion () {
      if (this.tinymceEditor && this.refineBookmark) {
        this.tinymceEditor.selection.moveToBookmark(this.refineBookmark);
        this.tinymceEditor.selection.setContent(this.refineSuggestedHtml);
      }
      this.closeRefineModal();
    },

    closeRefineModal () {
      if (this.refiningAi && this.refineAbortController) {
        this.refineAbortController.abort();
      }
      this.refineModalOpen = false;
      this.refineOriginalHtml = '';
      this.refineSuggestedHtml = '';
      this.refineSuggestionHistory = [];
      this.refineInstruction = '';
      this.refineStep = 'input';
      this.refineBookmark = null;
    }
  }
};
</script>
<style>
.box-model{
  width: 247px !important;
  height: 138px;
  border-radius: 8px;
  padding: 16px;
  gap: 8px;
  cursor: pointer;
}
.box-img{
  width: 56px;
  height: 56px;
  border-radius: 8px;
  padding: 16px;
  background-color: #E9ECEF;
}
.box-img-new{
  width: 56px;
  height: 56px;
  border-radius: 8px;
  padding: 16px;
  background-color: #ffffff;
}
@media screen and (max-width: 1450px) {
.box-model{
  width: 220px !important;
}
}

@media screen and (max-width: 1380px) {

.box-model{
  width: 200px !important;
}
}

@media screen and (max-width: 1200px) {
.box-model{
  width: 220px !important;
}
}

@media screen and (max-width: 1180px) {
  .box-model{
  width: 200px !important;
}
}

@media screen and (max-width: 1050px) {
  .box-model{
  width: 180px !important;
}
}
@media screen and (max-width: 992px) {
  .box-model{
  width: 150px !important;
}
}
@media screen and (max-width: 850px) {
  .box-model{
  width: 150px !important;
}
}
.tox {
  border-color: #CED4DA !important;
}
</style>
<template>
  <div class="container">
    <RequiredFill ref="RequiredFill" />
    <ProgressBarDocs />
    <transition name="ai-fade">
      <div v-if="aiModalOpen" class="ai-modal-overlay" @click.self="!generatingAi && (aiModalOpen = false)">
        <div class="ai-modal-dialog">
          <div class="ai-modal-header">
            <div class="ai-modal-title">
              Gerar conteúdo com IA
            </div>
            <button type="button" class="ai-modal-close" @click="closeAiModal">&times;</button>
          </div>
          <div class="ai-modal-body">
            <label class="ai-prompt-label">Descreva o que a IA deve gerar</label>
            <transition name="tip-slide">
              <div v-if="showTip" class="tip-box">
                <button type="button" class="tip-close-btn" @click="showTip = false" title="Fechar exemplo">&times;</button>
                <p class="tip-box-text">
                  <span class="tip-box-header">Exemplo:</span><br>
                  {{ aiPromptExample }}
                </p>
                <button type="button" class="tip-use-btn" @click="useAiPromptExample">
                  Usar este exemplo
                </button>
              </div>
            </transition>
            <textarea
              v-model="aiPrompt"
              :disabled="generatingAi"
              class="ai-prompt-textarea"
              placeholder="Digite aqui o prompt..."
              rows="5"
            ></textarea>
          </div>
          <div class="ai-modal-footer">
            <button type="button" class="ai-modal-cancel" @click="closeAiModal">Cancelar</button>
            <button type="button" class="ai-modal-confirm" :disabled="generatingAi" @click="confirmGenerateWithAI">
              <i v-if="generatingAi" class="pi pi-spin pi-spinner" style="font-size: 0.85rem;"></i>
              {{ generatingAi ? 'Gerando...' : 'Gerar' }}
            </button>
          </div>
        </div>
      </div>
    </transition>
    <transition name="ai-fade">
      <div v-if="refineModalOpen" class="ai-modal-overlay" @click.self="!refiningAi && closeRefineModal()">
        <div class="ai-modal-dialog">
          <div class="ai-modal-header">
            <div class="ai-modal-title">
              {{ refineWholeDocument ? 'Aprimorar documento com IA' : 'Revisar trecho com IA' }}
            </div>
            <button type="button" class="ai-modal-close" @click="closeRefineModal">&times;</button>
          </div>
          <div class="ai-modal-body">
            <div v-if="refiningAi" class="refine-loading">
              <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem;"></i>
              <span>Gerando sugestão...</span>
            </div>
            <template v-else-if="refineStep === 'input'">
              <label class="ai-prompt-label">{{ refineWholeDocument ? 'Texto atual' : 'Texto selecionado' }}</label>
              <div class="refine-text-block refine-text-original" v-html="refineOriginalHtml"></div>
              <label class="ai-prompt-label mt-3">O que você quer mudar?</label>
              <textarea
                v-model="refineInstruction"
                class="ai-prompt-textarea"
                :placeholder="refineWholeDocument ? 'Ex: reforce a importância do prazo e acrescente que a entrega será confirmada até quinta-feira...' : 'Ex: deixa mais formal, resume esse trecho...'"
                rows="4"
              ></textarea>
            </template>
            <template v-else>
              <label class="ai-prompt-label">Texto original</label>
              <div class="refine-text-block refine-text-original" v-html="refineOriginalHtml"></div>
              <label class="ai-prompt-label mt-3">Sugestão da IA</label>
              <div class="refine-text-block refine-text-suggested" v-html="refineSuggestedHtml"></div>
            </template>
          </div>
          <div class="ai-modal-footer">
            <template v-if="refineStep === 'input'">
              <button type="button" class="ai-modal-cancel" @click="closeRefineModal">Cancelar</button>
              <button type="button" class="ai-modal-confirm" :disabled="refiningAi || !refineInstruction.trim()" @click="confirmRefineInstruction">Revisar</button>
            </template>
            <template v-else>
              <button type="button" class="ai-modal-cancel" @click="closeRefineModal">Descartar</button>
              <button type="button" class="ai-modal-cancel" @click="backToRefineInstruction">Tentar de novo</button>
              <button type="button" class="ai-modal-confirm" :disabled="!refineSuggestedHtml" @click="applyRefineSuggestion">Aplicar</button>
            </template>
          </div>
        </div>
      </div>
    </transition>
    <div class="container mt-3">
      <div class="row">
        <h4 class="font-docs text-docs-black ml-1"><b>Dados do documento</b></h4>
      </div>

    <div class='row' style="margin-bottom: 5rem">
        <div class='col-sm-6 mt-1'>
            <label class="label-docs text-docs-black">Tipo</label>
                <select id='choices-category' v-model='typeSelect' class='my_form font-docs type-select' name='choices-category' @change="subject = ''">
                    <option v-for='option in typeDoc' :key='option.title' :value='option.id'>
                        {{ option.title }}
                    </option>
                </select>
            </div>

            <div class='col-sm-6 mt-1'>
                <label class="label-docs text-docs-black">Titulo <span style="color: red;">*</span></label>
                <input class="my_form text-bold" @input="subject = subject.toUpperCase()" v-model="subject" :placeholder="'Ex: ' + aiSubjectExample" type="text">
                <button v-if="showSubjectSuggestion" type="button" class="subject-suggestion-btn" @click="useSubjectSuggestion">
                  Usar exemplo
                </button>
            </div>
      </div>
      <hr>
      <div v-for="docTitle in typeDoc" :key="docTitle" class="row">
        <h4 v-if="typeSelect === docTitle.id && typeSelect === 0" class="font-docs text-docs-black ml-1 mt-3"><b>Aguardando tipo *</b></h4>
        <h4 v-if="typeSelect === docTitle.id && typeSelect !== 0" class="font-docs text-docs-black ml-1 mt-3"><b>{{ docTitle.title }}</b></h4>
      </div>
      <div class='row mt-2'>
        <label class="label-docs text-docs-black">Corpo do documento <span style="color: red;">*</span> <img src="../../../assets/img/info.png" alt="" title="O preenchimento do corpo do documento é obrigatório"></label>
        <div>
          <div class="ai-btn-row">
            <button type="button" class="ai-btn ms-auto" :disabled="!canGenerateWithAI" :title="canGenerateWithAI ? 'Gerar o corpo do documento com IA' : 'Preencha o título do documento primeiro'" @click="generateWithAI">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="white" style="flex-shrink:0;">
                <path d="M12 2 L13.5 9.5 L21 11 L13.5 12.5 L12 20 L10.5 12.5 L3 11 L10.5 9.5 Z"/>
                <path d="M19 2 L19.8 5.2 L23 6 L19.8 6.8 L19 10 L18.2 6.8 L15 6 L18.2 5.2 Z" opacity="0.85"/>
                <path d="M5 16 L5.6 18.4 L8 19 L5.6 19.6 L5 22 L4.4 19.6 L2 19 L4.4 18.4 Z" opacity="0.7"/>
              </svg>
              Gerar com IA
            </button>
            <button type="button" class="ai-btn ai-btn-refine ms-2" :disabled="!canRefineWithAI" :title="refineButtonTitle" @click="openRefineModal">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="white" style="flex-shrink:0;">
                <path d="M12 2 L13.5 9.5 L21 11 L13.5 12.5 L12 20 L10.5 12.5 L3 11 L10.5 9.5 Z"/>
                <path d="M19 2 L19.8 5.2 L23 6 L19.8 6.8 L19 10 L18.2 6.8 L15 6 L18.2 5.2 Z" opacity="0.85"/>
                <path d="M5 16 L5.6 18.4 L8 19 L5.6 19.6 L5 22 L4.4 19.6 L2 19 L4.4 18.4 Z" opacity="0.7"/>
              </svg>
              Revisar com IA
            </button>
          </div>
          <Editor style='border: 2px solid;' v-model='editorContent'
                    api-key='lhbldb066rsly0ci0sul37fjp28wklje4c2nh83d9eyc6w9z' :init='editorConfig' />
      </div>
        </div>
        <div class="d-flex justify-content-end">
          <button class="btn mt-3 font-docs Color-Docs" style="border: 1px solid #F1860B" @click="backProgress()">Voltar</button>
          <button class="btn mt-3 ml-3 font-docs text-white background-Docs" @click="nextProgress()">Avançar</button>
        </div>
      </div>
  </div>

</template>

<style scoped>
select#choices-category.type-select {
  background-color: #fff;
  padding-right: 2.5rem;
  color: #495057;
  font-size: 16px;
  cursor: pointer;
}
.ai-btn-row {
  display: flex;
  align-items: center;
  height: 2rem;
  margin-top: -1.75rem;
  margin-bottom: 0.5rem;
}
.ai-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.25rem 0.6rem 0.85rem;
  font-size: 0.82rem;
  font-weight: 700;
  border: none;
  border-radius: 0.6rem;
  background: linear-gradient(135deg, #7c3aed, #2563eb);
  color: #fff;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.15s;
  white-space: nowrap;
  letter-spacing: 0.03em;
  box-shadow: 0 3px 10px rgba(124, 58, 237, 0.4);
  line-height: 1;
}
.ai-btn:hover:not(:disabled) {
  opacity: 0.88;
  transform: translateY(-1px);
}
.ai-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
}
.ai-btn-refine {
  background: linear-gradient(135deg, #0ea5a5, #0d7fae);
  box-shadow: 0 3px 10px rgba(14, 165, 165, 0.4);
}
.refine-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  color: #6c757d;
  font-size: 1.05rem;
  padding: 2rem 0;
  flex: 1;
}
.refine-text-block {
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  padding: 0.85rem 1rem;
  font-size: 1.05rem;
  line-height: 1.45;
  color: #344767;
  max-height: 260px;
  overflow-y: auto;
  line-height: 1.6;
}
.refine-text-block :deep(*) {
  font-size: inherit;
  line-height: inherit;
}
.refine-text-block :deep(p) {
  margin: 0 0 0.4rem;
}
.refine-text-original {
  background: #f8f9fa;
  color: #6c757d;
}
.refine-text-suggested {
  background: #f0fdf7;
  border-color: #2dce89;
}
.ai-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
@media screen and (min-width: 992px) {
  .ai-modal-overlay {
    padding-left: 12rem;
  }
}
.ai-modal-dialog {
  background: #fff;
  border-radius: 1rem;
  width: 100%;
  max-width: 820px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: calc(100vh - 2rem);
}
.ai-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.1rem 1.5rem;
  background: #1a1a1a;
}
.ai-modal-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.15rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.02em;
}
.ai-modal-close {
  background: none;
  border: none;
  color: rgba(255,255,255,0.7);
  font-size: 1.9rem;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  transition: color 0.15s;
}
.ai-modal-close:hover {
  color: #fff;
}
.ai-modal-body {
  padding: 1.4rem 1.5rem 1.5rem;
  display: flex;
  flex-direction: column;
  min-height: 420px;
  overflow-y: auto;
}
.ai-prompt-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 700;
  color: #344767;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 0.5rem;
}
.tip-box {
  position: relative;
  background: #fffbea;
  border: 1px solid #fde68a;
  border-radius: 0.5rem;
  padding: 0.85rem 2.5rem 0.85rem 1rem;
  margin-bottom: 0.85rem;
}
.tip-close-btn {
  position: absolute;
  top: 0.25rem;
  right: 0.5rem;
  background: none;
  border: none;
  font-size: 1.6rem;
  line-height: 1;
  color: #92740a;
  cursor: pointer;
  padding: 0;
  opacity: 0.7;
  transition: opacity 0.15s;
}
.tip-close-btn:hover {
  opacity: 1;
}
.tip-box-header {
  font-size: 0.95rem;
  font-weight: 700;
  color: #92740a;
}
.tip-box-text {
  font-size: 0.95rem;
  color: #78350f;
  margin: 0 0 0.5rem;
  line-height: 1.55;
}
.subject-suggestion-btn {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.72rem;
  font-weight: 500;
  color: #2563eb;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
}
.subject-suggestion-btn:hover {
  text-decoration: underline;
}
.tip-use-btn {
  font-size: 0.95rem;
  font-weight: 600;
  color: #7c3aed;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
}
.tip-use-btn:hover {
  color: #2563eb;
}
.ai-prompt-textarea {
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 0.5rem;
  padding: 0.85rem 1rem;
  font-size: 1.05rem;
  color: #344767;
  resize: vertical;
  outline: none;
  transition: border-color 0.15s;
  font-family: inherit;
  flex: 1;
  min-height: 160px;
  line-height: 1.6;
}
.ai-prompt-textarea:focus {
  border-color: #1a1a1a;
}
.ai-prompt-textarea:disabled {
  background-color: #f8f9fa;
  color: #6c757d;
  cursor: not-allowed;
}
.ai-modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.5rem 1.25rem;
  border-top: 1px solid #f1f3f5;
}
.ai-modal-cancel {
  padding: 0.7rem 1.4rem;
  font-size: 1rem;
  font-weight: 600;
  border: 1.5px solid #dee2e6;
  border-radius: 0.5rem;
  background: #fff;
  color: #6c757d;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s;
}
.ai-modal-cancel:hover:not(:disabled) {
  border-color: #adb5bd;
  color: #344767;
}
.ai-modal-cancel:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  pointer-events: none;
}
.ai-modal-confirm {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.7rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 0.5rem;
  background: #1a1a1a;
  color: #fff;
  cursor: pointer;
  transition: background 0.15s;
}
.ai-modal-confirm:hover:not(:disabled) {
  background: #000;
}
.ai-modal-confirm:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  pointer-events: none;
}
.ai-fade-enter-active, .ai-fade-leave-active { transition: opacity 0.2s; }
.ai-fade-enter-from, .ai-fade-leave-to { opacity: 0; }
.tip-slide-enter-active, .tip-slide-leave-active { transition: opacity 0.18s, transform 0.18s; }
.tip-slide-enter-from, .tip-slide-leave-to { opacity: 0; transform: translateY(-4px); }
</style>
